import { CustomRouteObject } from '../../types/routes/Route.type';
import MainLayout from '../../layouts/MainLayout';
import QuestionDetail from '../../pages/QuestionDetail';
import { PopularQuestionPage } from '../../pages/PopularQuestionPage';
import { MyQuestionPage } from '../../pages/MyQuestionPage';
import QuestionCreatePage from '../../pages/QuestionCreatePage';
import QuestionEditPage from '../../pages/QuestionEditPage';

const question: CustomRouteObject = {
  id: 'questionRoot',
  path: '/question',
  element: <MainLayout />,
  children: [
    {
      id: 'questionCreate',
      path: 'create',
      element: <QuestionCreatePage />,
    },
    {
      id: 'questionEdit',
      path: 'edit/:questionId',
      element: <QuestionEditPage />,
    },
    {
      id: 'questionDetail',
      path: 'info/:questionId',
      element: <QuestionDetail />,
    },
    {
      id: 'questionPopular',
      path: 'popular',
      element: <PopularQuestionPage />,
    },
    {
      id: 'myquestions',
      path: 'myquestions',
      element: <MyQuestionPage />,
    },
  ],
};

export default question;
